import type { WorkspaceLayoutPreset } from 'generated/graphql';
import {
  applyWorkspaceLayoutPresetEvent,
  dispatchExtensionEvent,
} from 'domains/extension/extensionEventCreators';
import { logger } from 'modules/logger';

export function applyWorkspaceLayoutPreset(
  preset: Pick<WorkspaceLayoutPreset, 'id' | 'name' | 'windows'>
): void {
  if (preset.windows.length === 0) {
    logger.warn(
      `[WorkspaceLayoutManager] Skipping workspace layout preset ${preset.name} (${preset.id}) because it has no windows`
    );
    return;
  }

  dispatchExtensionEvent(applyWorkspaceLayoutPresetEvent({ preset }));
}
